
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResize_center as ObiResize_centerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-resize_center.js';
 
 
 

 
 export const ObiResize_center = createComponent({
   react: React,
   tagName: 'obi-resize_center',
   elementClass: ObiResize_centerElement,
   events: {
     
   }
  });
 
 